export default "__VITE_ASSET__4OT33zxA__"